import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { BeneficialOwnersStepContent } from "Components/Onboarding/BusinessEntity/Steps/BeneficialOwnersStep/BeneficialOwnersStepContent";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { useCurrentUserActingPersonParty } from "Hooks/useCurrentUserActingPersonParty";
import { useCurrentUsersPartyBeneficialOwners } from "Hooks/useCurrentUsersPartyBeneficialOwners";
import { useLoggedInUser } from "Hooks/useLoggedInUser";

type Props = {
  onNextStepRequested: () => void;
};

export const BeneficialOwnersStep = ({ onNextStepRequested }: Props) => {
  const { partyPublicID: userPartyPublicID } = useLoggedInUser() || {};
  const {
    isActingPartyOwner,
    ownerPartiesPublicIDs,
    isLoading: isBeneficialOwnersLoading,
  } = useCurrentUsersPartyBeneficialOwners({ excludeActingParty: true });
  const { actingPartyData, isLoading: isActingPersonPartyLoading } =
    useCurrentUserActingPersonParty();
  const { data: verificationData, isLoading: isVerificationLoading } =
    useVerificationsQuery();

  const isLoading =
    isBeneficialOwnersLoading ||
    isActingPersonPartyLoading ||
    isVerificationLoading;

  if (isLoading || !verificationData) {
    return <CenteredCircularProgress />;
  }

  return (
    <BeneficialOwnersStepContent
      onNextStepRequested={onNextStepRequested}
      isActingPartyOwner={isActingPartyOwner}
      ownerPartiesPublicIDs={ownerPartiesPublicIDs}
      verificationData={verificationData}
      userPartyPublicID={userPartyPublicID}
      actingPartyPublicID={actingPartyData?.publicID ?? undefined}
    />
  );
};
